import { Box, Flex, Text } from "@chakra-ui/react";

interface MethodTabProps {
    selected: boolean;
    icon: React.ReactNode;
    label: string;
    description: string;
    onClick: () => void;
}

export function MethodTab({ selected, icon, label, description, onClick }: MethodTabProps) {
    return (
        <Box
            flex={1}
            borderRadius="12px"
            border="2px solid"
            borderColor={selected ? "gray.100" : "brand.500" }
            bg={selected ? "white" : "brand.50" }
            p={4}
            cursor="pointer"
            transition="all 0.2s"
            onClick={onClick}
        >
            <Flex align="center" gap={3}>
                <Box color={selected ? "gray.400" : "brand.500" } flexShrink={0}>
                    {icon}
                </Box>
                <Box>
                    <Text fontSize="sm" fontWeight="600" color={selected ? "gray.700" : "brand.700" }>{label}</Text>
                    <Text fontSize="xs" color={selected ? "gray.400" : "brand.400" }>{description}</Text>
                </Box>
            </Flex>
        </Box>
    );
}
